import { Person } from 'models'
import { config } from 'config'
import { parseMarkdown } from './text-parsing'

export const buildObjects = <T extends object>(
  data: {
    values: Array<string[]>
  },
  people?: Person[]
) => {
  const dataCopy = data.values.slice()
  const columnNames = dataCopy.shift() as string[]

  const getColumnData = (columnName: string, value: string) => {
    return columnName === 'content' ? parseMarkdown(value, people) : value
  }

  const parsedData = dataCopy.map((row, rowIndex) =>
    row.reduce(
      (acc, value, index) => {
        const columnName = columnNames[index].toLowerCase()

        if (!value) {
          return acc
        }

        return {
          ...acc,
          [columnName]:
            acc[columnName as keyof typeof acc] &&
            Array.isArray(acc[columnName as keyof typeof acc])
              ? [
                  ...(acc[columnName as keyof typeof acc] as unknown as any[]),
                  getColumnData(columnName, value),
                ]
              : acc[columnName as keyof typeof acc]
              ? [
                  acc[columnName as keyof typeof acc],
                  getColumnData(columnName, value),
                ]
              : getColumnData(columnName, value),
        }
      },
      { id: rowIndex + 1 } as T
    )
  )

  return parsedData
}

export const getAge = (yearOfBirth: string) => {
  if (!yearOfBirth) {
    return ''
  }

  const birthYearNum = Number(yearOfBirth)

  if (isNaN(birthYearNum)) {
    return ''
  }

  return config.yearNow - birthYearNum
}

export const smoothScroll = (targetY: number, duration: number) => {
  const startingY = window.pageYOffset
  const diff = targetY - startingY
  let start: number
  const dur = (duration / 1000) * Math.abs(diff)

  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    const time = timestamp - start
    const percent = Math.min(time / dur, 1)

    window.scrollTo(0, startingY + diff * percent)

    if (time < dur) {
      window.requestAnimationFrame(step)
    }
  })
}
